import { useCallback, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { RootState, TypedDispatch } from 'redux/store'
import { setCanMakePayment, setWalletType } from './stripe-payment-request-slice'
import { setPaymentType } from '../payment-details/payment-details-slice'
import { PaymentMethod } from 'models/ChargeIntent'

const useStripePaymentRequest = () => {
  const dispatch = useDispatch<TypedDispatch<RootState>>()

  const { walletType, canMakePayment } = useSelector(
    (state: RootState) => state.order.stripePaymentRequest,
  )

  const currentPaymentType = useSelector((state: RootState) => state.order.paymentDetails.type)

  // Action to set whether payment can be made
  const setCanMakePaymentValue = useCallback(
    (value: boolean) => {
      dispatch(setCanMakePayment(value))

      // If digital wallets can't make payment and current payment type is DW,
      // change to CC as fallback
      if (!value && currentPaymentType === PaymentMethod.DW) {
        dispatch(setPaymentType(PaymentMethod.CC))
      }
    },
    [dispatch, currentPaymentType],
  )

  // Action to set the wallet type
  const setWalletTypeValue = useCallback(
    (walletType: 'APPLEPAY' | 'GPAY' | null) => {
      dispatch(setWalletType(walletType))
    },
    [dispatch],
  )

  return useMemo(
    () => ({
      walletType,
      canMakePayment,
      setCanMakePayment: setCanMakePaymentValue,
      setWalletType: setWalletTypeValue,
    }),
    [walletType, canMakePayment, setCanMakePaymentValue, setWalletTypeValue],
  )
}

export default useStripePaymentRequest
